export const PACKAGE_PRICING_MODES = [
  { value: 'ITEM_QUANTITY', label: 'Items as entered' },
  { value: 'PER_PAX', label: 'Per-PAX recipe' },
]

export const createPackageKey = () => `pkg-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`

export const normalizePackageMode = (value) => String(value || 'ITEM_QUANTITY').toUpperCase() === 'PER_PAX' ? 'PER_PAX' : 'ITEM_QUANTITY'

export const packageFromItem = (item = {}) => item.package_key ? ({
  key: String(item.package_key),
  name: item.package_name || 'Package',
  pax: Math.max(Number(item.package_pax || 1), 1),
  pricing_mode: normalizePackageMode(item.package_pricing_mode),
  sort_order: Number(item.package_sort_order || 0),
}) : null

export const packagesFromItems = (items = []) => {
  const byKey = new Map()
  items.forEach((item) => {
    const pkg = packageFromItem(item)
    if (pkg && !byKey.has(pkg.key)) byKey.set(pkg.key, pkg)
  })
  return [...byKey.values()].sort((a, b) => Number(a.sort_order || 0) - Number(b.sort_order || 0))
}

export const applyPackageDefinitions = (items = [], packages = []) => {
  const byKey = new Map((packages || []).map((pkg, index) => [String(pkg.key), { ...pkg, sort_order: index }]))
  return (items || []).map((item) => {
    const pkg = byKey.get(String(item.package_key || ''))
    if (!pkg) return { ...item, package_key: null, package_name: null, package_pax: null, package_pricing_mode: 'ITEM_QUANTITY', package_sort_order: null }
    return {
      ...item,
      package_key: pkg.key,
      package_name: pkg.name || 'Package',
      package_pax: Math.max(Number(pkg.pax || 1), 1),
      package_pricing_mode: normalizePackageMode(pkg.pricing_mode),
      package_sort_order: Number(pkg.sort_order || 0),
    }
  })
}

export const effectiveItemQuantity = (item = {}) => {
  const recipe = Math.max(Number(item.quantity || 0), 0)
  return normalizePackageMode(item.package_pricing_mode) === 'PER_PAX'
    ? recipe * Math.max(Number(item.package_pax || 1), 1)
    : recipe
}
